import React from "react";

function Side() {
  return (
    <div
      className="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 h-lg-100 pb-3 p-lg-0"
      id="container-auth-page-aside"
    >
      <div className="d-flex flex-column justify-content-lg-center h-100">
        <div>
          <img src="/assets/img/hilite-login-page.svg" />
        </div>
        <div className="text-center">
          <span className="badge bg-hilite font-weight-normal">ایران</span>
          <span className="px-1">پلتفرم تبلیغات آنلاین صنعت و ساختمان</span>
          <span className="badge bg-hilite font-weight-normal">اولین</span>
        </div>

        <div dir="rtl" className="d-flex justify-content-center pt-3">
          <div className="">
            <div className="d-flex">
              <div className="badge bg-hilite badge-feature-hilite">تخصصی</div>
              <div className="flex-grow-1"></div>
              <div className="flex-grow-1"></div>
            </div>
            <div className="d-flex">
              <div style={{ width: "80px" }}></div>
              <div className="badge bg-hilite badge-feature-hilite">هدفمند</div>
              <div className="flex-grow-1"></div>
            </div>
            <div className="d-flex">
              <div style={{ width: "80px" }}></div>
              <div style={{ width: "80px" }}></div>
              <div className="badge bg-hilite badge-feature-hilite">
                به صرفه
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Side;
